<template>
  <div v-if="showBanner" class="cookie-banner">
    <div class="cookie-content">
      <div class="cookie-icon">
        <i class="fas fa-cookie-bite"></i>
      </div>
      <div class="cookie-text">
        <h3>Nous utilisons des cookies</h3>
        <p>
          Ce site utilise des cookies pour assurer son bon fonctionnement et mesurer l'audience. 
          Vous pouvez à tout moment retirer votre consentement ou paramétrer vos choix.
        </p>
      </div>
      <div class="cookie-buttons">
        <GlassButton @click="acceptAllCookies" variant="primary" size="md">
          <template #icon><i class="fas fa-check"></i></template>
          Tout accepter
        </GlassButton>
        <GlassButton @click="acceptEssentialCookies" variant="secondary" size="md">
          <template #icon><i class="fas fa-shield-alt"></i></template>
          Seulement essentiels
        </GlassButton>
        <GlassButton @click="showSettings = true" variant="ghost" size="md">
          <template #icon><i class="fas fa-cog"></i></template>
          Paramétrer
        </GlassButton>
      </div>
    </div>
    
    <!-- Modal de paramétrage des cookies -->
    <GlassModal :show="showSettings" title="Paramétrage des cookies" @close="showSettings = false" size="md">
      <div class="cookie-settings">
        <div class="cookie-setting-item">
          <GlassCheckbox v-model="cookies.essential" disabled>
            <strong>Cookies essentiels</strong>
          </GlassCheckbox>
          <p class="setting-description">
            Ces cookies sont nécessaires au fonctionnement du site et ne peuvent pas être désactivés. 
            Ils permettent notamment l'authentification et la gestion de votre session.
          </p>
        </div>
        
        <div class="cookie-setting-item">
          <GlassCheckbox v-model="cookies.analytics">
            <strong>Cookies analytiques</strong>
          </GlassCheckbox>
          <p class="setting-description">
            Ces cookies nous permettent de mesurer l'audience (via Hotjar) et d'améliorer votre expérience utilisateur.
          </p>
        </div>
      </div>
      
      <template #footer>
        <GlassButton @click="saveCookieSettings" variant="primary">
          <template #icon><i class="fas fa-save"></i></template>
          Enregistrer mes choix
        </GlassButton>
      </template>
    </GlassModal>
  </div>
</template>

<script>
export default {
  name: 'CookieConsent',
  data() {
    return {
      showBanner: true,
      showSettings: false,
      cookies: {
        essential: true,
        analytics: false,
        // functional: false, // Commenté car non utilisé actuellement
        // marketing: false   // Commenté car non utilisé actuellement
      }
    }
  },
  created() {
    // Vérifier si l'utilisateur a déjà fait son choix
    const cookieConsent = localStorage.getItem('cookieConsent');
    if (cookieConsent) {
      this.showBanner = false;
      this.cookies = JSON.parse(cookieConsent);
    }
  },
  methods: {
    acceptAllCookies() {
      this.cookies = {
        essential: true,
        analytics: true,
        // functional: true, // Commenté car non utilisé actuellement
        // marketing: true   // Commenté car non utilisé actuellement
      };
      this.saveConsent();
    },
    acceptEssentialCookies() {
      this.cookies = {
        essential: true,
        analytics: false,
        // functional: false, // Commenté car non utilisé actuellement
        // marketing: false   // Commenté car non utilisé actuellement
      };
      this.saveConsent();
    },
    saveCookieSettings() {
      this.saveConsent();
      this.showSettings = false;
    },
    saveConsent() {
      // Enregistrer le consentement
      localStorage.setItem('cookieConsent', JSON.stringify(this.cookies));
      this.showBanner = false;
      
      // Émettre un événement pour que les autres composants puissent réagir
      this.$emit('cookies-updated', this.cookies);
    }
  }
}
</script>

<style scoped>
.cookie-banner {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(30, 40, 55, 0.98);
  backdrop-filter: blur(20px);
  color: var(--color-text);
  z-index: 1000;
  padding: 1.5rem;
  box-shadow: 0 -4px 30px rgba(0, 0, 0, 0.3);
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.cookie-content {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  gap: 1.5rem;
  flex-wrap: wrap;
}

.cookie-icon {
  font-size: 2.5rem;
  color: var(--color-warning);
}

.cookie-text {
  flex: 1;
  min-width: 300px;
}

.cookie-text h3 {
  margin: 0 0 0.5rem;
  font-size: 1.125rem;
  font-weight: 600;
  color: #ffffff;
}

.cookie-text p {
  margin: 0;
  font-size: 0.9rem;
  color: rgba(255, 255, 255, 0.7);
  line-height: 1.5;
}

.cookie-buttons {
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;
}

.cookie-settings {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.cookie-setting-item {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.setting-description {
  margin: 0 0 0 2rem;
  font-size: 0.875rem;
  color: var(--color-text-muted);
  line-height: 1.5;
}

@media (max-width: 768px) {
  .cookie-content {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .cookie-icon {
    display: none;
  }
  
  .cookie-buttons {
    width: 100%;
    flex-direction: column;
  }
}
</style>